



















import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class MenuOverlay extends Vue {
  @Prop() private currentRouteName!: string;

  isNotHome: boolean = false;
  isNotMyTimetables: boolean = false;
  isNotSettings: boolean = false;

  mounted() {
    this.initialise();
  }

  initialise(): void {
    this.isNotHome = this.currentRouteName !== "home";
    this.isNotMyTimetables = this.currentRouteName !== "myTimetables";
    this.isNotSettings = this.currentRouteName !== "settings";
  }

  openHomePage(): void {
    this.$emit("openPage", "home");
  }

  openMyTimetablesPage(): void {
    this.$emit("openPage", "myTimetables");
  }

  openSettingsPage(): void {
    this.$emit("openPage", "settings");
  }

  dismissMenu(): void {
    this.$emit("dismissMenu");
  }
}
